import { DataAttributeDefinitions, provideDataClass } from 'scrivito'

import { DataClassName, PisaDataClassEndpoint } from '@/Data/const'
import { createPisaRestApiConfig } from '@/Data/pisaClient'

const contactDocumentRelationDataClassName =
  DataClassName.CONTACT_DOCUMENT_RELATION
const contactDocumentRelationEndpoint = PisaDataClassEndpoint.CONTACT_DOCUMENT

export function pisaContactDocumentRelationDataClass(
  attributes: DataAttributeDefinitions,
) {
  return provideDataClass(contactDocumentRelationDataClassName, {
    title: contactDocumentRelationDataClassName,
    restApi: createPisaRestApiConfig(contactDocumentRelationEndpoint),
    attributes,
  })
}
